<script>
import spring from "@/assets/spring.gif";
import ttBlogImage from "@/assets/ttBlogImage.webp";
import resume from "@/assets/resume.webp";
import helloVideo from "@/../public/hello-video.mp4";
import {mapMutations} from "vuex";
import LaputaHero from "@/components/home/LaputaHero.vue";
import LaputaMedia from "@/components/home/LaputaMedia.vue";
import LaputaImageBanner from "@/components/home/LaputaImageBanner.vue";
import LaputaMomentList from "@/components/home/LaputaMomentList.vue";
import LaputaVideoBanner from "@/components/home/LaputaVideoBanner.vue";
import LaputaBlogCardList from "@/components/home/LaputaBlogCardList.vue";
import LaputaBook from "@/components/home/LaputaBook.vue";

export default {
  name: 'App',
  components: {
    LaputaProject: LaputaBook,
    LaputaMomentList, LaputaImageBanner, LaputaMedia, LaputaHero, LaputaVideoBanner, LaputaBlogCardList
  },
  data: function () {
    return {
      isFirstVisit: true,
      bigNews: true,
      blogList: [
        {
          id: 2,
          cover: spring,
          badge: "new",
          title: "Vue3性能优化实战",
          desc: "打包体积、首屏加载速度全方位优化方案",
          readTime: 22
        },
        {
          id: 3,
          cover: spring,
          badge: null,
          title: "SpringBoot统一返回封装",
          desc: "全局异常处理、统一响应体最佳实践",
          readTime: 12
        },
        {
          id: 1,
          cover: spring,
          badge: null,
          title: "Kubernetes部署笔记",
          desc: "简单梳理Deployment、Service日常使用踩坑",
          readTime: 25
        }
      ],
      ttBanner: {
        styleArr: [{backgroundImage: 'linear-gradient(180deg, #f25c64 0%, #d83c44 100%)'}],
        title: "今日头条",
        bigDescriptionHtml: "新奇的事物<span class=\"punctuation\">，</span><br>欢迎来头条看我<span class=\"punctuation\">。</span>",
        descriptionHtml: "<span class=\"description\">沉淀的日子总是安静无声的，<span class=\"description\">工作自我总结，并分享给他人<span class=\"inline-word\"><span class=\"punctuation\">。</span></span>",
        isRouter: false,
        buttonHref: "https://www.toutiao.com/c/user/token/MS4wLjABAAAAa2d5ACRu-OC7Uy7gmLREZ505FWuR4b3iA2VSmNMFPy4/?source=mine_profile",
        buttonName: "访问头条",
        buttonLink: "https://www.toutiao.com/article/7442895853792870922/?log_from=471425a058511_1786524525942",
        linkName: "最近最热的文章",
        pic: ttBlogImage
      },
      videoBanner: {
        styleArr: [],
        title: "天空之城",
        bigDescriptionHtml: "Hello<span class=\"punctuation\">，</span><br>第一次见面<span class=\"punctuation\">。</span>",
        descriptionHtml: "<span class=\"description\">这里存放我的练习、碎片思考与一些随手做出来的东西。</span><span class=\"description\">没有广告，没有推送，只是一处简单的数字角落<span class=\"punctuation\">。</span></span>",
        isRouter: false,
        isClick: true,
        buttonHref: "https://github.com/zhheo/Sticker-Heo",
        buttonName: "<svg width=\"28\" height=\"28\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "  <path d=\"M7 9L12 15L17 9\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "  <path d=\"M7 15L12 21L17 15\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
            "</svg>",
        buttonLink: "",
        linkName: "",
        videoUrl: helloVideo
      },
      resumeBanner: {
        styleArr: [
          {}
        ],
        title: "简历",
        // bigDescriptionHtml:"在编码中沉淀<span class=\"punctuation\">，</span><br>在复盘里成长<span class=\"punctuation\">。</span>",
        bigDescriptionHtml: "下一段经历<span class=\"punctuation\">，</span><br>也许可以一起创建<span class=\"punctuation\">。</span>",
        descriptionHtml: "<span class=\"description\">深耕Java/Spring生态、中间件，熟悉Vue前端开发，拥有6年+开发经历</span><br/>" +
            "<span class=\"description\">具备企业级Kubernetes云原生落地实践经验。</span>",
        isRouter: true,
        buttonHref: "/about/resume",
        buttonName: "查看我的简历",
        buttonLink: "mailto:wangpeng.developer@outlook.com?subject=来自个人主页的留言&body=你好，我想和你沟通：",
        linkName: "与我联系",
        pic: resume
      },
      AppList: {
        bigNews: true,
        title: "兴趣",
        description: "致力于构建买断制无广告的趁手小工具",
        cardList: [
          {
            id: new Date().getTime(),
            cardName: "敲木鱼",
            src: "",
            description: "将世间万物化作电子木鱼",
            tips: "买断制",
            type: "hot",
            button: "获取"
          }, {
            id: new Date().getTime(),
            cardName: "轻节食",
            src: "",
            description: "科学制定断食计划",
            tips: "",
            type: "new",
            button: "获取"

          }, {
            id: new Date().getTime(),
            cardName: "比例计",
            src: "",
            description: "设计师的高效比例计算工具",
            tips: "买断制",
            type: "",
            button: "获取"
          }, {
            id: new Date().getTime(),
            cardName: "DelSpace3",
            src: "",
            description: "文本自动化处理工具",
            tips: "买断制",
            type: "",
            button: "获取"
          }, {
            id: new Date().getTime(),
            cardName: "摸鱼",
            src: "",
            description: "可自定义的屏幕保护动画工具",
            tips: "买断制",
            type: "new",
            button: "获取"
          }
        ]
      }
    }
  },
  methods: {
    ...mapMutations('home', ['changeBigNews']),
  },
  mounted() {
    // 判断是否首次访问,关闭首页动画
    if (!window.localStorage.getItem('first_visit_flag')) {
      // 第一次访问
      window.localStorage.setItem('first_visit_flag', Date.now().toString())
      this.isFirstVisit = true
    } else {
      // 不是第一次
      this.isFirstVisit = false
    }
    // 判断之前是否关闭过大事件，是的话不在展示
    let bigNewsOpened = window.localStorage.getItem('bigNewsOpened')
    if ("false" === bigNewsOpened) {
      this.changeBigNews(false)
    }
  }
}
</script>

<template>
  <laputa-video-banner :banner="videoBanner" v-if="isFirstVisit"/>
  <laputaHero/>
  <LaputaBlogCardList/>
  <LaputaMomentList :article-list="blogList"/>
  <LaputaProject/>
  <laputa-image-banner :banner="ttBanner"/>
  <laputa-image-banner :banner="resumeBanner"/>
  <!--      <laputa-card-list :laputaCardList="AppList"/>-->
  <laputa-media/>
</template>

<style>

</style>